<template>
  <div class="page page-roadshow-list">
    <div class="list-options v-mt-sm">
      <a-form layout="inline" class="options-form">
        <a-row :gutter="24">
          <a-col span="8">
            <a-form-item :colon="false" label="申请单"><a-input placeholder="表单名称" @keyup.enter="handleSearch" allow-clear v-model="form.title" size="default" style="width: 200px" /></a-form-item>
          </a-col>
          <a-col span="8">
            <a-form-item :colon="false" label="创建日期">
              <a-range-picker :placeholder="['开始日期', '结束日期']" size="default" style="width: 200px" @change="onDateRangeChange" />
            </a-form-item>
          </a-col>
          <a-col span="8">
            <a-form-item :colon="false" label="单据状态">
              <a-select placeholder="请选择" v-model="form.state" size="default" style="width: 200px" allow-clear>
                <a-select-option :value="0">未预审</a-select-option>
                <a-select-option :value="1">已预审</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="flex items-center v-my-sm">
      <div class="v-ml-auto">
        <a-space>
          <a-button type="primary" icon="search" size="small" @click="handleSearch">查询</a-button>
        </a-space>
      </div>
    </div>
    <div class="list-table-container">
      <div class="list-toolbar flex items-center">
        <div class="list-toolbar-extra">
          共
          <span class="text-primary font-special">{{ pagination.total }}</span>
          条记录
        </div>
        <div class="list-pagination v-ml-auto">
          <a-pagination size="small" :current="pagination.page" :total="pagination.total" :pageSize="pagination.pageSize" show-size-changer show-quick-jumper @change="onPageChange" @showSizeChange="onPageChange" />
        </div>
      </div>
      <a-table class="list-table" size="small" :bordered="false" :pagination="false" :loading="loading" :data-source="list" :scroll="{ x: '100%' }" rowKey="id" @change="onTableChange">
        <a-table-column title="#" data-index="index" :width="45" align="center" fixed="left">
          <template slot-scope="text, record, index">{{ index + 1 }}</template>
        </a-table-column>
        <a-table-column title="操作" data-index="action" :width="100" align="center">
          <template slot-scope="text, record">
            <a-space class="table-actions" :size="6">
              <span class="hover-line text-indigo" title="预审处理" @click="$router.push(`view?id=${record.id}`)" v-if="record.state === 0 && hasPermission('project:form:review')">预审处理</span>
              <span class="hover-line text-indigo" title="查看" @click="$router.push(`view?id=${record.id}`)" v-else>查看</span>
            </a-space>
          </template>
        </a-table-column>
        <a-table-column title="状态" data-index="state" align="left" :width="120">
          <template slot-scope="text">
            <span class="text-red" v-if="text === 0">未预审</span>
            <span v-else-if="text === 1">已预审</span>
          </template>
        </a-table-column>
        <a-table-column title="申请单" data-index="form.title" :ellipsis="true" align="left">
          <template slot-scope="text, record">
            <router-link class="text-indigo hover-line" :title="text" :to="{ path: 'view', query: { id: record.id } }">{{ text || record.topic }}</router-link>
          </template>
        </a-table-column>
        <a-table-column title="申请学校/申请人/被推荐人" data-index="target" align="left" :ellipsis="true" :width="280" />
        <a-table-column title="申请单创建时间" data-index="supervisor" :width="200" align="center">
          <template slot-scope="text, record">
            <span v-if="record.createTime">{{ $moment(record.createTime * 1000).format('YYYY-MM-DD HH:mm') }}</span>
            <!-- <span v-if="record.dataUpdateTime">{{ record.dataUpdateTime.substring(0, 16) }}</span> -->
          </template>
        </a-table-column>
        <a-table-column title="表单来源" data-index="ptype" :width="85" align="left">
          <template slot-scope="text, record">
            <span v-if="record.ptype && ![1, 2, 3].includes(record.ptype)">活动表单</span>
            <span v-else>灵犀</span>
          </template>
        </a-table-column>
      </a-table>
      <div class="list-toolbar flex items-center">
        <div class="list-toolbar-extra">
          共
          <span class="text-primary font-special">{{ pagination.total }}</span>
          条记录
        </div>
        <div class="list-pagination v-ml-auto">
          <a-pagination size="small" :current="pagination.page" :total="pagination.total" :pageSize="pagination.pageSize" show-size-changer show-quick-jumper @change="onPageChange" @showSizeChange="onPageChange" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const form = {
  title: '',
  startDate: undefined,
  endDate: undefined,
  startTime: undefined,
  endTime: undefined,
  state: undefined,
}
const TAB_STATE = {
  all: null,
  going: [1],
  conclude: [2],
  closed: [3],
}
import { listLxFormData } from '@/api/lingxi'
export default {
  data() {
    return {
      tab: '',
      loading: false,
      list: [],
      pagination: {
        page: 1,
        pageSize: 20,
        total: 0,
      },
      form: { ...form },
      tabs: [],
    }
  },
  methods: {
    handleSearch() {
      this.load()
    },
    handleReset() {
      this.form.resetFields()
    },
    onDateRangeChange(date, dateString) {
      let [startDate, endDate] = dateString
      this.form.startDate = startDate
      this.form.endDate = endDate
    },
    onTableChange(pagination, filters, sorter) {
      if (sorter) {
        let { pageSize } = pagination
        let { field, order } = sorter
        if (order === 'ascend') {
          if (field === 'createTime') {
            this.load(1, pageSize, 'create_time asc')
          } else {
            this.load(1, pageSize, `${field} asc`)
          }
        } else if (order === 'descend') {
          if (field === 'createTime') {
            this.load(1, pageSize, 'create_time desc')
          } else {
            this.load(1, pageSize, `${field} desc`)
          }
        } else {
          this.load(1, pageSize, 'create_time desc')
        }
      }
    },
    load(page = 1, pageSize = 20, sorter) {
      this.loading = true
      let params = {
        page,
        pageSize,
        sorter,
        ...this.form,
      }
      if (this.tab !== 'all') {
        params.states = TAB_STATE[this.tab]
      }
      listLxFormData(params)
        .then(({ data }) => {
          if (data.success) {
            let { current, size, total, records } = data.result
            records.forEach(item => {
              item.data = JSON.parse(item.formData || '{}')
              item.json = JSON.parse(item.formJson || '{}')
              if (item.ptype == 2 || item.ptype == 4) {
                item.target = item.json['school_name'] && item.data[item.json['school_name']]
              } else if (item.ptype == 1 || item.ptype == 5) {
                item.target = item.json['applicant_name'] && item.data[item.json['applicant_name']]
              } else if (item.ptype == 3 || item.ptype == 6) {
                item.target = item.json['referral_name'] && item.data[item.json['referral_name']]
              }
            })
            this.list = records
            this.pagination = {
              page: current,
              pageSize: size,
              total,
            }
          }
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    onPageChange(page, pageSize) {
      this.load(page, pageSize)
    },
  },
  created() {
    this.load()
  },
}
</script>
